module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med tjenesteløfte_sekundærlogo_neg(hvit).101bc78f.png";